import React, { forwardRef } from "react";

import styles from "./Layout.module.scss";

function LayoutContent({ height, onScroll, children }, ref) {
  return (
    <div
      className={styles.layout__content}
      style={{
        height: height,
        overflowY: "scroll",
      }}
      ref={ref}
      onScroll={onScroll}
      id="layoutContent"
    >
      {children}
    </div>
  );
}

const Content = forwardRef(LayoutContent);

export default Content;
